import React, { Component } from 'react';
import ImageButtonList from '../common/imageButtonList';
import ImageBackground from '../common/imageBackground';
import ImageHeader from '../common/imageHeader';
import ImageText from '../common/imageText';
import NavigationBar from '../common/navigationBar';
import './styles.css';

export default class AssignedEducationPrompts extends Component {
  header = {
    id: 'header',
    src: require('./images/1244_Prompts_elements.png')
  };
  prompts = {
    id: 'prompts',
    src: require('./images/1244_EduPrompts.png')
  };
  promptButtons = [
    {
      id: 'view-now',
      to: '/assigned_education/roles',
      highlight: require('./images/ViewNow_HL.png'),
      unhighlight: require('./images/ViewNow_UH.png'),
      alt: 'View Now'
    },
    {
      id: 'view-later',
      to: decodeURIComponent(this.props.match.params.back),
      highlight: require('./images/ViewLater_HL.png'),
      unhighlight: require('./images/ViewLater_UH.png'),
      alt: 'View Later'
    }
  ];
  promptButtonList = {
    top: 355,
    left: 280
  };
  navigationBar = {
    mainMenu: true,
    back: true,
    backRoute: null,
    doGoBack: true
  };
  previousLocation = null;

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="service-1244">
        <ImageBackground id="background" />
        <ImageHeader {...this.header} />
        <ImageText {...this.prompts} />
        <ImageButtonList {...this.promptButtonList} imageButtons={this.promptButtons} />
        <NavigationBar {...this.navigationBar} />
      </div>
    );
  }
}
